// extracted by mini-css-extract-plugin
export default {"Wrap":"pages_Wrap__37zfJ","PaddingSidebar":"pages_PaddingSidebar__WOMS6","PaddingWrap":"pages_PaddingWrap__cNAEf","PaddingHeader":"pages_PaddingHeader__D1Q2q"};